import { useMutation, useQueryClient } from "@tanstack/react-query";
import { roleApi } from "../services/role.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  ROLE_MESSAGES_ERROR,
  ROLE_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useEnableRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => roleApi.enable(id),
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(ROLE_MESSAGES_ERROR.ENABLE_ERROR);
        return;
      }
      successNotification(ROLE_MESSAGES_SUCCESS.ENABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["roles"] });
    },
    onError: () => {
      errorNotification(ROLE_MESSAGES_ERROR.ENABLE_ERROR);
    },
  });
};

export const useDisableRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => roleApi.disable(id),
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(ROLE_MESSAGES_ERROR.DISABLE_ERROR);
        return;
      }
      successNotification(ROLE_MESSAGES_SUCCESS.DISABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["roles"] });
    },
    onError: () => {
      errorNotification(ROLE_MESSAGES_ERROR.DISABLE_ERROR);
    },
  });
};
